<template>
  <svg class="check_animated_icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
    <path fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
  </svg>
</template>

<script>
export default {
  name: "CheckAnimatedIcon",
  props: {
    fill: {
      type: String,
      default: '#fff'
    }
  }
}
</script>
